var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon11(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8643 13.8049V12.8173C17.8643 10.6324 17.8643 8.86719 23.4603 8.86719H26.2583C31.8544 8.86719 31.8544 10.6324 31.8544 12.8173V13.8049",
    fill: "#E0F3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0939 26.974V28.6199C26.0939 28.6364 26.0939 28.6364 26.0939 28.6528C26.0939 30.4469 26.0816 31.9117 23.6251 31.9117C21.1809 31.9117 21.1562 30.4633 21.1562 28.6693V26.974C21.1562 25.3281 21.1562 25.3281 22.3907 25.3281H24.8595C26.0939 25.3281 26.0939 25.3281 26.0939 26.974Z",
    fill: "#A020FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6672 43.3333H32.3338C39.7038 43.3333 41.0238 40.3817 41.4088 36.7883L42.7838 22.1217C43.2788 17.6483 41.9955 14 34.1672 14H15.8338C8.0055 14 6.72216 17.6483 7.21716 22.1217L8.59216 36.7883C8.97716 40.3817 10.2972 43.3333 17.6672 43.3333Z",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8643 13.8023V12.4856C17.8643 9.57238 17.8643 7.21875 23.4603 7.21875H26.2583C31.8544 7.21875 31.8544 9.57238 31.8544 12.4856V13.8023",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6663 26.8333V28.6667C28.6663 28.685 28.6663 28.685 28.6663 28.7033C28.6663 30.7017 28.648 32.3333 24.9997 32.3333C21.3697 32.3333 21.333 30.72 21.333 28.7217V26.8333C21.333 25 21.333 25 23.1663 25H26.833C28.6663 25 28.6663 25 28.6663 26.8333Z",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.691 23.1641C38.456 26.2441 33.616 28.0774 28.666 28.7007",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80273 23.6641C11.9277 26.4874 16.5844 28.1924 21.3327 28.7241",
    stroke: "#081E54",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon-11.a53f425306d37732cf5ca279f995d0a9.svg";
export { ForwardRef as ReactComponent };